var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c, _d;
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { MDCLinearProgressFoundation } from '@material/linear-progress';
import withRender from './LinearProgress.html';
import { addClass, hasClass, removeClass, setStyleEl } from '../util/dom';
function makeAdaptor(vm, el) {
    return {
        addClass: addClass(vm),
        removeClass: removeClass(vm),
        hasClass: hasClass(el),
        getBuffer: () => vm.$refs.buffer,
        getPrimaryBar: () => vm.$refs.primary,
        setStyle: setStyleEl
    };
}
// FIELDS
export const ACTIVE = 'active';
export const DETERMINATE = 'determinate';
export const VALUE = 'value';
export const REVERSE = 'reverse';
let LinearProgress = class LinearProgress extends Vue {
    constructor() {
        super(...arguments);
        this.classes_ = {};
        this.styles_ = {};
    }
    mounted() {
        const adapter = makeAdaptor(this, this.$el);
        this.foundation = new MDCLinearProgressFoundation(adapter);
        this.onDeterminate();
        this.onReverse();
        this.onActive();
        this.onValue();
        this.foundation.init();
    }
    onValue() {
        this.foundation.setProgress(this.value.progress);
        this.foundation.setBuffer(this.value.buffer);
    }
    onDeterminate() {
        this.foundation.setDeterminate(this.determinate);
        if (this.value) {
            this.onValue();
        }
    }
    onReverse() {
        this.foundation.setReverse(this.reverse);
    }
    onActive() {
        if (this.active) {
            this.foundation.open();
        }
        else {
            this.foundation.close();
        }
    }
    beforeDestroy() {
        this.foundation.destroy();
    }
};
_a = DETERMINATE, _b = VALUE, _c = ACTIVE, _d = REVERSE;
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], LinearProgress.prototype, _a, void 0);
__decorate([
    Prop({ default: () => ({ buffer: 0, progress: 0 }) }),
    __metadata("design:type", Object)
], LinearProgress.prototype, _b, void 0);
__decorate([
    Prop({ default: true }),
    __metadata("design:type", Boolean)
], LinearProgress.prototype, _c, void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], LinearProgress.prototype, _d, void 0);
__decorate([
    Watch(VALUE),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], LinearProgress.prototype, "onValue", null);
__decorate([
    Watch(DETERMINATE),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], LinearProgress.prototype, "onDeterminate", null);
__decorate([
    Watch(REVERSE),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], LinearProgress.prototype, "onReverse", null);
__decorate([
    Watch(ACTIVE),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], LinearProgress.prototype, "onActive", null);
LinearProgress = __decorate([
    withRender,
    Component({})
], LinearProgress);
export default LinearProgress;
//# sourceMappingURL=LinearProgress.js.map